import * as THREE from 'three';

import { DDSLoader } from 'three/examples/jsm/loaders/DDSLoader.js';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js';
import { TGALoader } from 'three/examples/jsm/loaders/TGALoader';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';

const manager = new THREE.LoadingManager();
manager.addHandler(/\.dds$/i, new DDSLoader());
manager.addHandler(/\.tga$/i, new TGALoader());

export async function load(path, objName, mtlName) {
    return new Promise((resolve, reject) => {
        new MTLLoader(manager)
            .setPath(path)
            .load(mtlName, function (materials) {

                materials.preload();

                new OBJLoader(manager)
                    .setMaterials(materials)
                    .setPath(path)
                    .load(objName, function (object) {

                        resolve(object)

                    }, (e) => {
                        console.log('on progress..', e)
                    }, reject);

            });
    })
}
